











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {WebserviceIntegracao} from '@/model/resource/WebserviceIntegracao'
import {WebserviceIntegracaoCollection} from '@/model/collection/WebserviceIntegracaoCollection'
import {ListWebserviceIntegracaoSchema} from '@/schema/resource/WebserviceIntegracao/ListWebserviceIntegracaoSchema'
import {CsvWebserviceIntegracaoSchema} from '@/schema/resource/WebserviceIntegracao/CsvWebserviceIntegracaoSchema'

@Component
export default class ListWebserviceIntegracaoView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListWebserviceIntegracaoSchema()
  collection = new WebserviceIntegracaoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: WebserviceIntegracao) {
    Helper.pushByName('editWebserviceIntegracao', item.idWebserviceFk as number)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new WebserviceIntegracaoCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvWebserviceIntegracao()
    new CsvWebserviceIntegracaoSchema().downloadCsv(csv.all())
  }
}
